import { seededRandom } from "../../tripmovie/sequences/introDrawing";

// The loop and the marker stroke come from the trip reel's own introDrawing.ts, so the hand-drawn
// circle here is the same hand as the one in the trip reel and the city guide. Only the underline
// is new.

// a hand-drawn underline: a slightly bowed stroke with a flick at the end
export const swoosh = (x0: number, x1: number, y: number, seed = 3, samples = 40): number[][] => {
	const rand = seededRandom(seed);
	const bow = 6 + 6 * rand();
	const out: number[][] = [];
	for (let i = 0; i <= samples; i++) {
		const u = i / samples;
		const x = x0 + (x1 - x0) * u;
		out.push([x, y + Math.sin(u * Math.PI) * bow - u * u * 10 + Math.sin(u * 9 + rand()) * 1.2]);
	}
	return out;
};
